import React from "react";

export const ProcessingGroupsLabel = (props) => {


    return (
            <div>{props.groupNames?.map(group =>
                <span style={{textAlign: 'center'}}>{group + ';'} </span>
                )}
            </div>
    )
}